import {
  FAILURE_FETCH_X_CSRF_TOKEN,
  REQUEST_FETCH_X_CSRF_TOKEN,
  SET_DEVICE_VARIANT,
  SET_ROOT_PATH,
  SET_X_CSRF_TOKEN,
  SUCCESS_FETCH_X_CSRF_TOKEN,
} from 'actions/actionTypes';
import { AppActionTypes, AppState } from 'types/app';

export const initialState: AppState = {
  isInitializedXCSRFToken: false,
  xCSRFToken: '',
  rootPath: '',
  deviceVariant: '',
};

const appReducer = (state = initialState, action: AppActionTypes): AppState => {
  switch (action.type) {
    case REQUEST_FETCH_X_CSRF_TOKEN: {
      return {
        ...state,
      };
    }
    case SUCCESS_FETCH_X_CSRF_TOKEN: {
      const { xCSRFToken } = action;
      return {
        ...state,
        isInitializedXCSRFToken: true,
        xCSRFToken,
      };
    }
    case FAILURE_FETCH_X_CSRF_TOKEN: {
      return {
        ...state,
      };
    }
    case SET_X_CSRF_TOKEN: {
      const { xCSRFToken } = action;
      return {
        ...state,
        xCSRFToken,
      };
    }
    case SET_ROOT_PATH: {
      const { rootPath } = action;
      return {
        ...state,
        rootPath,
      };
    }
    case SET_DEVICE_VARIANT: {
      const { userDevice } = action;
      return {
        ...state,
        deviceVariant: userDevice,
      };
    }
    default: {
      return state;
    }
  }
};

export default appReducer;
